import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, deleteDoc, doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import StyledTable from './StyledTable';
import { highlightMatch } from '../utils/highlightMatch'; // adjust the path if needed
import { useTenant } from "../context/TenantContext";
import ConfirmDialog from './ConfirmDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { toast } from 'react-toastify';



const DoctorList = () => {
  const [doctors, setDoctors] = useState([]);
  const [search, setSearch] = useState('');
  const { tenantId, loading } = useTenant();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [doctorToDelete, setDoctorToDelete] = useState(null);

  useEffect(() => {
  if (loading || !tenantId) return;

  const q = query(collection(db, 'doctors'), where('tenantId', '==', tenantId));

  // Real-time listener
  const unsubscribe = onSnapshot(q, (snap) => {
    setDoctors(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  });

  return () => unsubscribe(); // cleanup
}, [tenantId, loading]);


  const handleDeleteClick = (doctors) => {
      setDoctorToDelete(doctors);
      setConfirmOpen(true);
    };
  
    const confirmDelete = async () => {
      try {
        await deleteDoc(doc(db, 'doctors', doctorToDelete.id));
        setDoctors(prev => prev.filter(p => p.id !== doctorToDelete.id));
        toast.success('Doctor deleted');
      } catch (err) {
        console.error('Delete failed:', err);
        toast.error('Failed to delete');
      } finally {
        setConfirmOpen(false);
        setDoctorToDelete(null);
      }
    };

       const highlightMatch = (text, query) => {
  if (!text) return '';
  if (!query) return text;

  const regex = new RegExp(`(${query})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? <mark key={index}>{part}</mark> : part
  );
};

  const filtered = doctors.filter(d =>
    (d.name?.toLowerCase().includes(search.toLowerCase()) ||
     d.phone?.includes(search))
  );

  return (
    <div className="patient-list-container">
      <div className="search-container">
        <input 
          type="text" 
          placeholder="Search by name or phone..." 
          value={search}
          onChange={e => setSearch(e.target.value)} 
        />
      </div>
      <StyledTable
        headers={['Name', 'Phone', 'Email', 'Actions']}
        data={filtered}
        renderRow={(d) => (
            <>
              <div>{highlightMatch(d.name, search)}</div>
              <div>{highlightMatch(d.phone, search)}</div>
              <div>{highlightMatch(d.email, search)}</div>
              <div className="delete-btn" onClick={() => handleDeleteClick(d)}>
                <FontAwesomeIcon icon="trash" className="unauth-trash-icon" />
              </div>
            </>
            
          )}
        />
        <ConfirmDialog
        open={confirmOpen}
        title="Delete Doctor?"
        message={`Are you sure you want to delete "${doctorToDelete?.name}"?`}
        onConfirm={confirmDelete}
        onCancel={() => setConfirmOpen(false)}
      />
    </div>
  );
};

export default DoctorList;
